export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
export const REMOVE_ERROR_MESSAGE = 'REMOVE_ERROR_MESSAGE';
export const SHOW_LOADING_INDICATOR = 'SHOW_LOADING_INDICATOR';
export const REMOVE_LOADING_INDICATOR = 'REMOVE_LOADING_INDICATOR';